/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';

export interface IStateOSDProps {
  image?: string;
  titleNormalText?: string;
  titleBoldText?: string;
  description?: string;
  buttonText?: string;
  onButtonClick?(): void;
  backgroundImage?: string;
}

export const StateOSD = ({
  image,
  titleNormalText,
  titleBoldText,
  description,
  buttonText,
  onButtonClick,
  backgroundImage,
}: IStateOSDProps) => {
  const _renderImageIf = () => {
    if (image) {
      return <Image src={image} className='img-fluid w-75' />;
    }
  };
  const _renderTitleIf = () => {
    if (titleNormalText) {
      return (
        <h3 className='mt-5' style={{ color: '#000000' }}>
          {`${titleNormalText} `}{' '}
          {titleBoldText && (
            <span className='fw-bolder' style={{ color: '#000000' }}>
              {titleBoldText}
            </span>
          )}
        </h3>
      );
    }
  };
  const _renderDescriptionIf = () => {
    if (description) {
      return (
        <p className='lead my-4' style={{ color: '#000000' }}>
          {description}
        </p>
      );
    }
  };
  const _renderButtonIf = () => {
    if (buttonText) {
      return (
        <Button
          variant={'primary'}
          className='d-inline-flex align-items-center justify-content-center mb-4'
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      );
    }
  };
  return (
    <div
      style={{
        //backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        height: '100vh',
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            className='text-center d-flex align-items-center justify-content-center'
            style={{ background: '#F9F0EB', height: '100vh' }}
          >
            <div>
              {_renderImageIf()}
              {_renderTitleIf()}
              {_renderDescriptionIf()}
              {_renderButtonIf()}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

StateOSD.defaultProps = {};
